import type { BrokerSusepScreening } from '@/shared/api/resources';
import { Alert } from '@/shared/ui/Alert';

/**
 * O resultado da triagem do cadastro do corretor na SUSEP (ADR 0095), como as telas de
 * cadastro o mostram: a corretora apta segue com o aviso do registro; a que nao esta
 * apta para com a mensagem; com a consulta desligada no servidor, um aviso discreto.
 *
 * A tela so antecipa a resposta: o servidor confere de novo ao gravar.
 */
export function AvisoDaSusep({
  triagem,
}: {
  triagem: BrokerSusepScreening | null | undefined;
}) {
  if (!triagem || triagem.status === 'nao_consultada') return null;
  if (triagem.status === 'apta') {
    return <Alert tone="success">{triagem.message}</Alert>;
  }
  if (triagem.status === 'nao_configurada') {
    return (
      <p className="text-2xs text-ink-500" data-testid="susep-nao-configurada">
        {triagem.message}
      </p>
    );
  }
  return (
    <Alert
      tone="danger"
      title={
        triagem.status === 'indisponivel'
          ? 'SUSEP indisponivel'
          : 'Corretora nao habilitada na SUSEP'
      }
    >
      {triagem.message}
    </Alert>
  );
}
